var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C969427-6578-4A28-B78B-3928D4FF250E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03---Forgot-Password",
    transform: "translate(-1371.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_close",
    transform: "translate(1371.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#142945",
    opacity: 0.149999991,
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3553837,22.6354969 C11.5284674,22.8089635 11.7707844,22.9130435 12.0131015,22.9130435 C12.2554186,22.9130435 12.4804274,22.8263102 12.6708194,22.6354969 L16.9979102,18.2988313 L21.3250011,22.6354969 C21.4980848,22.8089635 21.7404018,22.9130435 21.9827189,22.9130435 C22.225036,22.9130435 22.4500448,22.8263102 22.6404368,22.6354969 C23.0039124,22.271217 23.0039124,21.6814305 22.6404368,21.3344972 L18.3133459,16.9978317 L22.6404368,12.6611661 C23.0039124,12.2968862 23.0039124,11.7070997 22.6404368,11.3601665 C22.2769611,10.9958865 21.7057851,10.9958865 21.3423095,11.3601665 L17.0152186,15.696832 L12.6881277,11.3601665 C12.3246521,10.9958865 11.7534761,10.9958865 11.3900004,11.3601665 C11.0265248,11.7244464 11.0265248,12.3142329 11.3900004,12.6611661 L15.7170913,16.9978317 L11.3900004,21.3344972 C10.9919081,21.6987771 10.9919081,22.271217 11.3553837,22.6354969 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.9e5411a6892a5d293211fe4b850af7d1.svg";
export { ForwardRef as ReactComponent };